import styled from 'styled-components';
import { muiCheckCircleOutline } from '@ally/metronome-icons';
import { Box, TextBody, Button, Icon } from '@ally/metronome-ui';
import { muiAllyTheme } from '../../../utils';

const StyledIcon = styled(Icon)`
  vertical-align: middle;
  margin-left: 10px;
`;

interface IProps {
  children?: React.ReactNode;
  shown?: boolean;
  title: string;
  submitCard?: Function;
  isSubmitted?: boolean;
  footerComponent?: React.ReactNode;
  submitButtonContent?: string;
  showHelpMessage?: boolean;
  disableButton?: boolean;
}

const ConsentAccordion: React.FC<IProps> = (
  props: React.PropsWithChildren<IProps>
) => {
  return (
    <Box
      backgroundColor='white'
      borderLeft={`1px solid ${muiAllyTheme.colors['gray-400']}`}
      borderRight={`1px solid ${muiAllyTheme.colors['gray-400']}`}
      borderBottom={`1px solid ${muiAllyTheme.colors['gray-400']}`}
    >
      <Box
        display='flex'
        justifyContent='flex-start'
        alignItems='center'
        height='45px'
        backgroundColor='gray-200'
        paddingLeft='10px'
        borderTop={`1px ${muiAllyTheme.colors['gray-400']} solid`}
        borderBottom={
          props.shown ? `5px solid ${muiAllyTheme.colors['gray-400']}` : ``
        }
      >
        {props.isSubmitted && (
          <StyledIcon icon={muiCheckCircleOutline} size='lg' fill='green-500' />
        )}
        <Box paddingLeft='10px'>
          <TextBody tag='span' size='md' weight='bold'>
            {props.title}
          </TextBody>
        </Box>
      </Box>
      {props.shown && (
        <Box padding='20px'>
          {props.children}

          <Button
            variant={props.disableButton ? 'disabled' : 'primary'}
            disabled={props.disableButton}
            text={props.submitButtonContent || 'Agree and Continue'}
            size='md'
            onClick={() => {
              if (props.submitCard) {
                props.submitCard();
              }
            }}
          />

          {props.footerComponent && (
            <Box paddingTop='20px'>{props.footerComponent}</Box>
          )}
        </Box>
      )}
    </Box>
  );
};

export default ConsentAccordion;
